import React from 'react'
import Select from 'react-select'

const modes = [
  { value: 'cover', label: 'Recouvre toute la zone (peut être rognée)' },
  { value: 'contain', label: 'Visible en totalité (bandes vides possibles)' },
  { value: 'stretch', label: 'Étirée sur toute la zone (déformée)' }
]

/**
 * Mode d'affichage d'une image (`cover`, `contain`, `stretch`, valeurs de `resizeMode` côté application). Le premier
 * choix retire la valeur ; il annonce ce que l'application fait alors : `ui:options.defaultMode` nomme le mode appliqué
 * par défaut, qui n'est alors pas reproposé à part (une valeur égale au défaut s'affiche comme lui), ou
 * `ui:options.defaultLabel` le décrit librement (repli sur le thème, par exemple).
 */
export const ResizeModePicker = ({ formData, onChange, schema, uiSchema }) => {
  const { defaultMode, defaultLabel } = uiSchema?.['ui:options'] || {}
  const defaultModeLabel = modes.find(mode => mode.value === defaultMode)?.label
  const emptyOption = {
    value: undefined,
    label: defaultLabel || (defaultModeLabel ? `Par défaut : ${defaultModeLabel}` : 'Non défini')
  }
  const options = [emptyOption, ...modes.filter(mode => defaultLabel || mode.value !== defaultMode)]

  return (
    <div>
      <label className="control-label">{schema.title}</label>
      {schema.description && <p className="field-description">{schema.description}</p>}
      <Select
        value={options.find(option => option.value === formData) || emptyOption}
        onChange={option => onChange(option.value)}
        options={options}
        isMulti={false}
        menuPortalTarget={document.body}
        menuPlacement="auto"
        styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
      />
    </div>
  )
}
